<template>
  <div>
      <div class="text-center mb-4 d-flex centered vertically-centered">
        <h3 class="title text-center m-0">Instructions sent!</h3>
      </div>

      <div class="text-center d-flex column centered">
        <p style="max-width: 700px;">We have sent an email to {{ userStore.email }} with instructions for completing your password reset. You will have 10 minutes to complete the reset, otherwise you will need to request a new email.</p>
        <br>
        <p>If you encounter any issues, don’t hesitate to reach out to our <router-link to="/contact" @click="$emit('modal-close')">support team</router-link></p>
      </div>
  </div>
</template>

<style scoped>

</style>

<script setup>
  import { useUserStore } from '@/stores/user'
  const userStore = useUserStore()
</script>
